var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 36,
    height: 36,
    rx: 7.8646,
    fill: "#00389C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3275 10.5017C26.3255 8.57389 24.8365 7.01172 22.9999 7.01172C21.1622 7.01172 19.6724 8.57602 19.6724 10.5057C19.6724 12.4353 21.1622 13.9996 22.9999 13.9996C24.8364 13.9996 26.3253 12.4377 26.3275 10.51V10.5017Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9488 12.94C14.9471 11.2971 13.6782 9.96582 12.1131 9.96582C10.5469 9.96582 9.27734 11.2989 9.27734 12.9433C9.27734 14.5878 10.5469 15.9209 12.1131 15.9209C13.6781 15.9209 14.9469 14.5898 14.9488 12.947V12.94Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 20.8829C17 19.1612 18.1017 17.6326 19.7351 17.0882L20.4702 16.8432C22.1123 16.2958 23.8877 16.2958 25.5298 16.8432L26.2649 17.0882C27.8983 17.6326 29 19.1612 29 20.8829V26.9999H17V20.8829Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7532 18.5225C14.9712 18.5952 15.1787 18.6873 15.374 18.7966C15.131 19.4514 15 20.1557 15 20.8829V26.9993H7.00928V21.9406C7.00928 20.3897 8.00166 19.0129 9.47292 18.5225L9.83429 18.402C11.3134 17.909 12.9126 17.909 14.3918 18.402L14.7532 18.5225Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers);
export default __webpack_public_path__ + "static/media/customers.d8aaf71b50cce72a578915c41702c0c5.svg";
export { ForwardRef as ReactComponent };